export interface Article {
  slug: string;
  title: string;
  category: string;
  excerpt: string;
  content: string;
  author: string;
  authorAvatar: string;
  publishDate: string;
  readTime: string;
  tags: string[];
  imageUrl: string;
}

export const articles: Article[] = [
  {
    slug: 'ruhe-gaoxiao-qicao-hetong',
    title: '如何高效在线起草合同：2024年团队协作完全指南',
    category: 'hetong-qicao',
    excerpt: '了解如何使用在线协作工具高效起草合同文件，从模板选择到多人协作编辑，再到最终审核签批，一站式掌握合同起草全流程。',
    content: `<p>在现代商业环境中，合同起草是每个企业不可或缺的工作环节。传统的合同起草方式往往需要通过邮件反复发送修改版本，效率低下且容易出错。使用一起草.com 的在线协作平台，团队成员可以实时共同编辑合同文件，大幅提升工作效率。</p>
<h2>为什么选择在线协作起草合同？</h2>
<p>在线协作起草合同具有以下显著优势：首先，多人可以同时在线编辑同一份合同，修改内容实时可见；其次，系统自动保存历史版本，随时可以回溯到之前的版本；第三，支持在线批注和讨论，团队成员可以直接在合同内容上进行交流。</p>
<h3>第一步：选择合适的合同模板</h3>
<p>一起草.com 提供了丰富的合同模板库，涵盖采购合同、服务协议、保密协议、劳动合同等多种类型。选择与需求匹配的模板作为起点，可以节省大量从零开始编写的时间。</p>
<h3>第二步：分配协作角色和权限</h3>
<p>确定参与合同起草的团队成员，根据角色分配不同的编辑权限。法务人员可以拥有审核权限，业务人员可以拥有编辑权限，管理层可以拥有审批权限。合理的权限设置确保合同起草过程既高效又安全。</p>
<h3>第三步：实时协作编辑</h3>
<p>团队成员可以同时在线编辑合同内容，系统会以不同颜色标识每位成员的修改。所有变更实时同步，无需手动合并版本。内置的评论功能让团队成员可以在特定条款上展开讨论。</p>
<h3>第四步：审核与签批</h3>
<p>完成编辑后，合同进入审核流程。审核人可以在线添加批注和修改建议，编辑者可以逐条处理这些反馈。最终版本确定后，支持电子签章功能，快速完成签批。</p>
<h2>最佳实践建议</h2>
<p>在使用在线协作起草合同时，建议建立清晰的合同模板管理体系，定期更新模板以符合最新法规要求。同时，养成添加详细修改说明的习惯，方便团队成员了解每次变更的原因。最后，利用平台的版本对比功能，确保最终版本与预期一致。</p>`,
    author: '张明远',
    authorAvatar: '张',
    publishDate: '2024-08-10',
    readTime: '8 分钟',
    tags: ['合同起草', '团队协作', '在线工具'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20modern%20office%20workspace%20with%20laptop%20displaying%20document%20collaboration%20interface%2C%20warm%20natural%20light%2C%20clean%20minimal%20desk%20setup%2C%20soft%20ambient%20aesthetic%2C%20editorial%20photography%20style%2C%20neutral%20cream%20and%20warm%20beige%20tones%2C%20professional%20atmosphere&width=800&height=450&seq=article-hetong-01&orientation=landscape',
  },
  {
    slug: 'tuandui-wendang-xiezuo-jiaocheng',
    title: '团队文档协作入门教程：从零开始掌握云端写作',
    category: 'tuandui-xiezuo',
    excerpt: '一份面向初学者的完整团队文档协作教程，涵盖平台注册、项目创建、成员邀请、实时编辑和版本管理等核心功能的使用方法。',
    content: `<p>随着远程办公和分布式团队的普及，云端文档协作已经成为现代工作方式的核心组成部分。一起草.com 为团队提供了强大的在线协作写作平台，本文将带您从零开始，全面掌握云端文档协作的各项功能。</p>
<h2>平台注册与团队创建</h2>
<p>首先，访问一起草.com 官网，使用企业邮箱或手机号注册账号。注册完成后，您可以创建团队空间，邀请团队成员加入。平台支持按部门、项目或临时工作组建不同的协作空间，灵活满足各种组织需求。</p>
<h3>创建您的第一个协作文档</h3>
<p>在团队空间中，点击"新建文档"即可开始。您可以选择从空白文档开始，也可以使用平台提供的丰富模板。文档创建后，系统会自动保存，您随时可以从上次编辑的位置继续。</p>
<h3>邀请成员参与协作</h3>
<p>通过链接分享或直接添加成员邮箱的方式邀请同事参与文档协作。您可以为每位成员设置不同的权限：查看、评论或编辑。精细的权限控制确保文档安全性。</p>
<h3>实时协作的核心体验</h3>
<p>当多人同时编辑一份文档时，每位成员的编辑内容会以不同颜色高亮显示，光标位置实时可见。这种"所见即所得"的协作体验让团队成员如同坐在同一间会议室里讨论和写作。</p>
<h2>版本管理与历史记录</h2>
<p>平台自动保存文档的每次修改记录，您可以随时查看历史版本，对比不同版本之间的差异。如果需要回退到之前的版本，只需一键操作即可完成。版本管理功能让您无需担心误操作导致的内容丢失。</p>
<h2>评论与讨论功能</h2>
<p>团队成员可以在文档的任意位置添加评论，针对具体内容展开讨论。所有评论按时间线排列，讨论完成后可以标记为已解决。这种精准的沟通方式避免了在即时通讯工具中零散讨论文档问题的困扰。</p>`,
    author: '李思涵',
    authorAvatar: '李',
    publishDate: '2024-08-08',
    readTime: '10 分钟',
    tags: ['团队协作', '入门教程', '云端写作'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20collaborative%20workspace%20with%20multiple%20people%20working%20on%20shared%20documents%2C%20warm%20lighting%2C%208K%20resolution%2C%20editorial%20photography%2C%20clean%20professional%20style%2C%20soft%20neutral%20tones%2C%20team%20collaboration%20atmosphere%2C%20modern%20office%20interior%20design&width=800&height=450&seq=article-tuandui-01&orientation=landscape',
  },
  {
    slug: 'shangye-fangan-zhuanxie-jiqiao',
    title: '商业方案撰写技巧：如何在协作中产出高质量策划书',
    category: 'fangan-cehua',
    excerpt: '掌握商业方案撰写的核心技巧，了解如何通过团队协作提升方案质量，从结构设计到内容优化，让每一份方案都更具说服力。',
    content: `<p>一份优秀的商业方案不仅需要清晰的逻辑和充实的内容，更需要团队的集思广益。在一起草.com 平台上，团队可以高效协作撰写商业方案，将各自的专业知识和创意融入策划书中。</p>
<h2>商业方案的核心结构</h2>
<p>一份完整的商业方案通常包含以下核心部分：项目概述与背景分析、市场调研与竞争分析、项目目标与关键指标、实施方案与时间规划、资源需求与预算安排、风险评估与应对策略。使用一起草.com 的结构化模板，可以确保方案逻辑清晰、层次分明。</p>
<h3>分工协作的策略</h3>
<p>根据团队成员的专业领域进行合理分工：市场人员负责市场分析和竞品研究，技术人员负责技术方案设计，财务人员负责预算和收益预测，项目经理负责整体统筹和时间规划。每个人在自己擅长的领域贡献内容，最终通过协作整合为一份完整的方案。</p>
<h3>内容优化的迭代流程</h3>
<p>初稿完成后，团队成员轮流审阅并提出修改建议。使用平台的评论功能，可以针对特定段落展开深入讨论。经过多轮迭代优化，方案的质量和说服力会显著提升。</p>
<h2>让方案更具说服力的技巧</h2>
<p>数据是方案说服力的基础。在方案中引用权威数据和研究报告，用图表直观展示关键信息。同时，注重方案的叙事逻辑，从一个引人入胜的问题出发，逐步展开解决方案，最终以清晰的行动号召收尾。</p>`,
    author: '王思睿',
    authorAvatar: '王',
    publishDate: '2024-08-05',
    readTime: '7 分钟',
    tags: ['方案策划', '商业写作', '写作技巧'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Business%20proposal%20writing%20workspace%20with%20laptop%20and%20documents%2C%20warm%20natural%20light%2C%20professional%20modern%20office%20setting%2C%20clean%20minimal%20aesthetic%2C%20editorial%20photography%2C%20soft%20cream%20and%20warm%20beige%20background%2C%20creative%20professional%20atmosphere&width=800&height=450&seq=article-fangan-01&orientation=landscape',
  },
  {
    slug: 'neirong-yingxiao-xiezuo-zhinan',
    title: '内容营销协作写作指南：团队如何共创优质内容',
    category: 'chuangyi-neirong',
    excerpt: '探索内容营销团队如何利用在线协作工具高效共创优质内容，从选题策划到内容发布，实现内容生产的流程化和标准化。',
    content: `<p>在内容为王的时代，持续产出高质量内容是品牌建设的关键。然而，优质内容的创作往往需要多人协作——文案、设计、SEO专家、产品经理各自贡献专业知识。一起草.com 为内容团队提供了理想的协作环境。</p>
<h2>建立内容创作流程</h2>
<p>高效的内容团队需要标准化的创作流程。使用一起草.com，您可以建立从选题到发布的全流程管理：选题池管理、内容大纲评审、初稿协作撰写、多轮审校优化、最终审核发布。每个环节都有明确的负责人和截止时间。</p>
<h3>头脑风暴与选题策划</h3>
<p>在协作文档中开设专门的选题讨论区，团队成员可以随时添加创意灵感。定期组织在线选题会，利用实时协作功能同步讨论和筛选选题，确定内容优先级和排期。</p>
<h3>协作撰写与风格统一</h3>
<p>多位作者协作撰写同一篇内容时，风格统一是常见挑战。通过建立内容风格指南文档并在协作平台中共享，所有参与者都能遵循统一的语调、用词和格式规范。平台的样式模板功能可以自动应用预设格式。</p>
<h2>提升内容质量的审校流程</h2>
<p>建立多层次的审校机制：同行审校关注内容准确性和逻辑性，编辑审校关注语言表达和风格一致性，SEO审校关注关键词优化和搜索友好度。使用平台的变更追踪功能，每条修改都有据可查。</p>`,
    author: '陈雨萱',
    authorAvatar: '陈',
    publishDate: '2024-08-01',
    readTime: '6 分钟',
    tags: ['创意内容', '内容营销', '写作协作'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Creative%20content%20team%20brainstorming%20session%20with%20digital%20devices%2C%20warm%20lighting%2C%20modern%20creative%20workspace%2C%20sticky%20notes%20and%20whiteboard%2C%20editorial%20photography%20style%2C%20soft%20neutral%20tones%2C%20collaborative%20creative%20atmosphere&width=800&height=450&seq=article-chuangyi-01&orientation=landscape',
  },
  {
    slug: 'hetong-moban-xuanze-jiqiao',
    title: '合同模板选择与定制：找到最适合您业务需求的模板',
    category: 'wendang-moban',
    excerpt: '如何从海量合同模板中快速找到最适合的，并进行个性化定制？本文为您详细解析合同模板的选择标准与定制方法。',
    content: `<p>合同模板是提高合同起草效率的重要工具，但如何从众多模板中选择最合适的并进行有效定制，是很多用户面临的挑战。一起草.com 提供了数百种经过法律专家审核的合同模板，本文将帮助您快速找到并定制最适合的模板。</p>
<h2>合同模板的分类体系</h2>
<p>一起草.com 的合同模板按行业、用途和复杂度进行了系统分类。常见类别包括：商务合作类（采购合同、服务协议、合作协议）、人力资源类（劳动合同、保密协议、竞业限制协议）、知识产权类（授权协议、转让合同）、租赁类（房屋租赁、设备租赁）等。</p>
<h3>如何选择正确的模板</h3>
<p>选择合同模板时，需要关注以下几点：首先，明确合同的法律性质和目的；其次，考虑合同涉及的具体业务场景；第三，评估合同复杂度和风险等级。平台为每个模板提供了适用场景说明和法律要点提示，帮助您快速做出选择。</p>
<h3>模板的个性化定制</h3>
<p>选定模板后，您可以根据具体业务需求进行定制。常见的定制内容包括：修改合同主体信息、调整关键条款内容、增加特殊约定条款、补充附件和附录。使用一起草.com 的在线编辑器，定制过程直观便捷，修改内容实时预览。</p>
<h2>模板定制的注意事项</h2>
<p>在定制合同模板时，请务必注意：不要随意删除模板中的关键法律条款；确保所有空白字段都已正确填写；对于不理解的条款，建议咨询法律专业人士；定制后的合同应进行完整的审核流程。平台提供的法律条款说明可以帮助您理解每个条款的含义和作用。</p>`,
    author: '赵明哲',
    authorAvatar: '赵',
    publishDate: '2024-07-28',
    readTime: '7 分钟',
    tags: ['合同模板', '文档定制', '使用技巧'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20document%20template%20library%20displayed%20on%20modern%20screen%2C%20warm%20ambient%20lighting%2C%20professional%20legal%20document%20aesthetic%2C%20clean%20minimal%20design%2C%20editorial%20photography%2C%20soft%20cream%20and%20beige%20tones&width=800&height=450&seq=article-moban-01&orientation=landscape',
  },
  {
    slug: 'yuancheng-tuandui-wendang-guanli',
    title: '远程团队文档管理最佳实践：安全与效率的双重保障',
    category: 'tuandui-xiezuo',
    excerpt: '面向远程办公团队，分享文档管理的最佳实践，包括权限设置、版本控制、安全策略和协作规范，确保文档管理既高效又安全。',
    content: `<p>远程办公模式下，文档管理面临着安全与效率的双重挑战。如何确保团队成员能够便捷地访问所需文档，同时保护敏感信息安全不被泄露？一起草.com 提供了一套完整的远程文档管理解决方案。</p>
<h2>建立清晰的文档组织架构</h2>
<p>良好的文档组织是高效协作的基础。建议按照项目、部门或功能模块建立分层级的文件夹结构。使用统一的命名规范，让每位团队成员都能快速定位所需文档。一起草.com 支持拖拽式文件管理和智能搜索功能，大大提升了文档查找效率。</p>
<h3>权限管理体系</h3>
<p>精细的权限管理是文档安全的核心保障。一起草.com 支持四级权限设置：管理员（完全控制）、编辑者（可编辑和分享）、评论者（仅可评论）、查看者（仅可查看）。根据团队成员的角色和职责，合理分配权限，确保信息在正确的人之间流通。</p>
<h3>版本控制策略</h3>
<p>启用自动版本管理功能，所有文档的修改历史都会被完整记录。为重要文档设置版本里程碑，便于快速定位关键节点。当需要回退时，可以精确恢复到任意历史版本，避免误操作造成的内容损失。</p>
<h2>安全策略与合规要求</h2>
<p>对于涉及敏感信息的文档，建议开启额外的安全保护措施：设置文档访问密码、启用操作审计日志、配置IP访问白名单。对于需要满足合规要求的行业，平台支持数据本地化存储和加密传输。</p>`,
    author: '刘浩然',
    authorAvatar: '刘',
    publishDate: '2024-07-25',
    readTime: '9 分钟',
    tags: ['远程办公', '文档管理', '安全策略'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Remote%20team%20document%20management%20digital%20workspace%2C%20modern%20home%20office%20setup%2C%20laptop%20with%20cloud%20document%20interface%2C%20warm%20natural%20lighting%2C%20clean%20minimal%20aesthetic%2C%20soft%20neutral%20tones%2C%20professional%20atmosphere&width=800&height=450&seq=article-tuandui-02&orientation=landscape',
  },
  {
    slug: 'fangan-shuxie-jiegouhua-fangfa',
    title: '方案书写的结构化方法：从框架到细节的完整指南',
    category: 'fangan-cehua',
    excerpt: '掌握方案书写的结构化方法，学习如何使用标准化框架提升方案质量，让每一份方案都条理清晰、逻辑严密、说服力强。',
    content: `<p>一份优秀的方案就像一栋精心设计的建筑——需要有稳固的框架和精巧的细节。使用结构化的方法来撰写方案，可以确保方案的完整性、逻辑性和可执行性。一起草.com 的平台功能天然支持结构化写作，让方案创作更加高效。</p>
<h2>金字塔原理在方案中的应用</h2>
<p>金字塔原理是方案写作的经典方法论。核心思想是结论先行，以上统下，归类分组，逻辑递进。在方案开头明确提出核心观点或建议，然后逐层展开支撑论据和具体方案。一起草.com 的大纲模式非常适合金字塔结构的方案写作。</p>
<h3>方案框架的四大支柱</h3>
<p>每个完整的方案都应包含四大支柱：问题定义（我们面对什么挑战）、解决方案（我们如何应对）、实施计划（我们怎样落地）、预期效果（我们期待什么成果）。使用平台的结构化模板，确保四个支柱得到充分展开。</p>
<h3>细节填充的协作方式</h3>
<p>框架搭建完成后，团队成员可以分工协作填充各部分的细节内容。擅长数据分析的同事负责市场数据部分，技术专家负责技术方案部分，项目经理负责实施计划部分。利用实时协作功能，确保各部分内容的连贯性和一致性。</p>
<h2>方案评审与迭代优化</h2>
<p>完整的方案需要经过多轮评审和优化。建立结构化的评审清单：逻辑是否自洽、数据是否准确、方案是否可行、表达是否清晰。使用一起草.com 的批注功能，评审人可以对具体内容提出修改建议，写作者逐条响应和修改。</p>`,
    author: '林思远',
    authorAvatar: '林',
    publishDate: '2024-07-20',
    readTime: '8 分钟',
    tags: ['方案策划', '结构化写作', '方法论'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Structured%20document%20writing%20workspace%20with%20outline%20and%20mindmap%20on%20screen%2C%20warm%20ambient%20light%2C%20modern%20minimal%20office%2C%20clean%20professional%20aesthetic%2C%20editorial%20photography%2C%20soft%20neutral%20tones&width=800&height=450&seq=article-fangan-02&orientation=landscape',
  },
  {
    slug: 'chuangyi-tuandui-xiezuo-liucheng',
    title: '创意团队协作流程优化：从灵感捕捉到作品交付',
    category: 'chuangyi-neirong',
    excerpt: '优化创意团队的协作流程，建立从灵感收集、方案讨论到作品交付的标准化流程，让创意产出更加稳定和高效。',
    content: `<p>创意工作看似自由随性，但实际上，高效的创意团队往往拥有清晰的协作流程。一起草.com 为创意团队提供了灵活而有序的协作平台，帮助团队在保持创造力的同时提升产出效率。</p>
<h2>建立创意团队的协作流程</h2>
<p>一个完整的创意协作流程通常包括：灵感收集阶段、创意筛选阶段、方案深化阶段、作品制作阶段、反馈优化阶段和最终交付阶段。每个阶段都需要团队成员的不同程度参与和不同类型的协作。</p>
<h3>灵感收集与共享</h3>
<p>在协作平台中创建灵感收集文档，团队成员可以随时添加创意点子、参考资料和灵感素材。定期组织在线灵感分享会，团队成员轮流展示自己的创意构思，其他人补充和延展。这种开放式的创意共享是优秀作品的孵化器。</p>
<h3>协作创作的核心环节</h3>
<p>确定创意方向后，团队成员根据各自的专长分工协作。文案撰写核心内容，设计师提供视觉支持，策略师确保创意与目标一致。使用一起草.com 的实时协作功能，各部分工作同步推进，创意在碰撞中不断升华。</p>
<h2>反馈文化的重要性</h2>
<p>建设性的反馈是创意优化的关键。在团队中建立"反馈三原则"：对事不对人、提供具体建议而非笼统评价、关注改进可能性而非问题本身。利用平台的评论功能，反馈可以精准对应到具体内容，避免沟通歧义。</p>`,
    author: '周雨晴',
    authorAvatar: '周',
    publishDate: '2024-07-15',
    readTime: '6 分钟',
    tags: ['创意协作', '流程优化', '工作方法'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Creative%20team%20workspace%20with%20colorful%20posters%20and%20design%20tools%2C%20warm%20natural%20lighting%2C%20modern%20studio%20setting%2C%20creative%20atmosphere%2C%20editorial%20photography%2C%20soft%20neutral%20and%20warm%20tones&width=800&height=450&seq=article-chuangyi-02&orientation=landscape',
  },
  {
    slug: 'moban-guanli-gaoji-jiqiao',
    title: '文档模板管理高级技巧：构建企业专属模板库',
    category: 'wendang-moban',
    excerpt: '学习如何构建和管理企业专属的文档模板库，从模板设计、版本管理到团队推广，打造标准化的企业文档体系。',
    content: `<p>对于有一定规模的企业来说，建立专属的文档模板库是提升整体写作效率和质量的关键举措。一起草.com 支持企业创建和管理自定义模板库，本文将从模板设计、管理到推广，全面介绍企业模板库的建设方法。</p>
<h2>模板库建设的战略价值</h2>
<p>企业专属模板库不仅能够提升文档产出效率，更重要的是确保企业文档的品牌一致性、合规性和专业水准。统一的模板体系可以让每位员工产出的文档都符合企业标准，降低审核成本，提升企业形象。</p>
<h3>模板设计原则</h3>
<p>好的企业模板应遵循以下原则：结构清晰，层次分明；内容全面，覆盖常见场景；格式规范，符合企业品牌指南；灵活性好，适应不同业务需求。使用一起草.com 的模板编辑器，可以轻松创建符合企业标准的专业模板。</p>
<h3>模板的版本管理</h3>
<p>随着业务发展和法规变化，模板需要不断更新迭代。建立规范的模板版本管理机制：每次重大更新创建新版本，保留历史版本以备查阅，通过版本日志记录每次更新的内容和原因。平台自动记录模板的修改历史，版本管理轻松有序。</p>
<h2>模板的团队推广与使用</h2>
<p>模板的价值在于被广泛使用。制定模板使用规范，在团队中进行培训宣导。将常用模板设为快捷入口，方便快速调用。定期收集使用反馈，根据实际需求不断优化模板内容。一起草.com 的团队空间功能天然支持模板的共享和管理。</p>`,
    author: '吴佳宁',
    authorAvatar: '吴',
    publishDate: '2024-07-10',
    readTime: '8 分钟',
    tags: ['模板管理', '企业文档', '最佳实践'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Corporate%20document%20template%20library%20management%20interface%20on%20modern%20screen%2C%20warm%20lighting%2C%20professional%20office%20setting%2C%20clean%20minimal%20aesthetic%2C%20editorial%20photography%2C%20soft%20neutral%20and%20warm%20beige%20tones&width=800&height=450&seq=article-moban-02&orientation=landscape',
  },
  {
    slug: 'hetong-shencha-xiezuo-yaodian',
    title: '合同审查协作要点：多人审阅模式下的效率提升方法',
    category: 'hetong-qicao',
    excerpt: '在多人协作审查合同的场景下，如何高效组织审阅流程？本文分享合同审查协作的关键要点和最佳实践方法。',
    content: `<p>合同审查往往需要多个角色参与——法务审核法律风险，财务审核商务条款，业务审核操作可行性。一起草.com 的多人协作审阅模式让合同审查过程更加有序高效。</p>
<h2>建立合同审查的标准流程</h2>
<p>高效的合同审查需要清晰的流程：合同初稿提交 → 并行分发审阅 → 汇总审查意见 → 修改与确认 → 最终定稿。使用一起草.com 的任务分配功能，每个审阅者都能清楚自己的审阅范围和截止时间。</p>
<h3>并行审阅与串行审阅</h3>
<p>根据合同类型和紧急程度，选择合适的审阅模式。对于标准合同，可以采用并行审阅模式，不同角色的审阅者同时进行审阅，大大缩短审阅周期。对于复杂合同，建议采用串行审阅模式，按专业领域依次审阅，确保每个环节都充分把关。</p>
<h3>审阅意见的高效管理</h3>
<p>使用平台的批注功能，审阅者可以在合同条款旁直接添加修改建议。所有批注按条款位置聚合显示，避免意见分散。对于有争议的修改建议，可以在批注中展开讨论直至达成共识。审阅完成后，清理所有已解决的批注，保持文档整洁。</p>
<h2>提升审阅质量的关键因素</h2>
<p>制定统一的审阅标准和检查清单，确保每次审阅都覆盖所有关键风险点。建立合同知识库，将常见问题和处理方案沉淀下来，供团队参考。定期复盘审阅过程中发现的问题，持续优化审阅流程和检查标准。</p>`,
    author: '黄志远',
    authorAvatar: '黄',
    publishDate: '2024-07-05',
    readTime: '7 分钟',
    tags: ['合同审查', '协作流程', '效率提升'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Legal%20document%20review%20workspace%20with%20annotations%20on%20screen%2C%20warm%20ambient%20light%2C%20professional%20office%20environment%2C%20clean%20minimal%20aesthetic%2C%20editorial%20photography%2C%20soft%20cream%20and%20warm%20tones&width=800&height=450&seq=article-hetong-02&orientation=landscape',
  },
];

export const articleMap: Record<string, Article> = {};
articles.forEach((article) => {
  articleMap[article.slug] = article;
});

export function getArticlesByCategory(categorySlug: string): Article[] {
  return articles.filter((a) => a.category === categorySlug);
}